<template>
	<div class="ReLeadStaffInfo mt-3" v-if="objData">
		<div class="staffBlock pb-1" v-if="objData.staff_info_poz_name!=''">
			<h6>{{ objData.staff_info_poz_name }}</h6>	
			<p class="d-flex">{{ structure_name }}</p>
			<div class="d-flex justify-content-between">
				<div class="d-flex mr-3 align-items-center" v-if="objData.staff_info_mobile_phone && objData.staff_info_mobile_phone !=''">
					<p  class="mr-2"><b>Моб.: </b>{{ objData.staff_info_mobile_phone }}</p>
					<template v-if="this.lead_id && this.lead_id !=''">
						<RePhoneCallButton
							v-if="objData.staff_info_mobile_phone && objData.staff_info_mobile_phone !=''"
							:phone="objData.staff_info_mobile_phone"
							:lead_id="this.lead_id"
							borderStyle="noborder"
						/>
					</template>
				</div>

				<div class="d-flex align-items-center" v-if="objData.staff_info_internal_phone && objData.staff_info_internal_phone !=''">
					<p class="mr-2"><b>Доб.: </b>{{ objData.staff_info_internal_phone }}</p>
					<template v-if="this.lead_id && this.lead_id !=''">
						<RePhoneCallButton
							v-if="objData.staff_info_internal_phone && objData.staff_info_internal_phone !=''"
							:phone="objData.staff_info_internal_phone"
							:lead_id="this.lead_id"
							borderStyle="noborder"
						/>
					</template>
				</div>
			</div>
			<!-- <template v-if="this.lead_id && this.lead_id !='' && this.objData.staff_info_code !=null">
				<ReLeadMessageButton 
					v-if="typeof objStaffExtra[objData.staff_info_code].id != 'undefined' && objStaffExtra[this.objData.staff_info_code].telegram_id != '' && objStaffExtra[this.objData.staff_info_code].telegram_id>0 && objStaffExtra[this.objData.staff_info_code].telegram_active==1"
					
					:staff_name="objData.staff_info_fio"
					:staff_code="objData.staff_info_code"
					:contact_value="objStaffExtra[this.objData.staff_info_code].telegram_id"
					:obj_type="'LEAD'" 
					:obj_id="this.lead_id"
					:obj_name="'callcenter'"
					/>
				<div v-else class="d-flex w-100 text-warning">Телеграм ответственного не подключен!</div>
			</template> -->
			
		</div>

		<div class="bossBlock pt-2" v-if="objData.staff_info_boss_name && objData.staff_info_boss_name!=''">
				<p class="" v-if="objData.staff_info_boss_name && objData.staff_info_boss_name !=''"><b>Руководитель: </b>{{ objData.staff_info_boss_name }}</p>
				
				<div class="d-flex justify-content-between">
					<div class="d-flex mr-3 align-items-center" v-if="objData.staff_info_boss_mobile_phone && objData.staff_info_boss_mobile_phone !=''">
						<p class="mr-2"><b>Моб.: </b>{{ objData.staff_info_boss_mobile_phone }}</p>
						<template v-if="this.lead_id && this.lead_id !=''">
							<RePhoneCallButton
								v-if="objData.staff_info_boss_mobile_phone && objData.staff_info_boss_mobile_phone !=''"
								:phone="objData.staff_info_boss_mobile_phone"
								:lead_id="this.lead_id"
								borderStyle="noborder"
							/>
						</template>
					</div>
					<div class="d-flex align-items-center" v-if="objData.staff_info_boss_internal_phone && objData.staff_info_boss_internal_phone !=''">
						<p class="mr-2"><b>Доб.: </b>{{ objData.staff_info_boss_internal_phone }}</p>
						<template v-if="this.lead_id && this.lead_id !=''">
							<RePhoneCallButton
								v-if="objData.staff_info_boss_internal_phone && objData.staff_info_boss_internal_phone !=''"
								:phone="objData.staff_info_boss_internal_phone"
								:lead_id="this.lead_id"
								borderStyle="noborder"
							/>
						</template>
					</div>
				</div>
		</div>

		


	</div>

</template>

<!-- что нужно от компонента: "только вызов API для звонка. скорее всего надо передать "идентификатор лида" и номер на который вызов" -->

<script>
	import { Button } from 'element-ui';
	import RePhoneCallButton from "src/our_components/RePhoneCallButton.vue";
	// import ReBranchPrint from 'src/our_components/ReBranchPrint.vue';
	// import ReLeadMessageButton from "src/our_components/ReLeadMessageButton.vue";

	export default {
		name: 'ReLeadStaffInfo',
		components: {
			[Button.name]: Button,
			RePhoneCallButton,
			// ReLeadMessageButton,
			// ReBranchPrint,
		},
		props: {
			value: [Object],
			lead_id: [Number, String],
			objData: [Object, String],
		},
		data () {
			return {
				ver: 1,
			}
		},
		watch: {

		},
		computed: {
			structure_name(){
				if(this.objData && this.objData.staff_info_structure_name){
					const parts = String(this.objData.staff_info_structure_name).split('>');
					return parts.slice(-2).join('>');
				}
				return '';
			}
		},
		methods: {
			// getExtraDataForMessage(){
			// 	console.log('beforeMount getExtraDataForMessage',this.objData.staff_info_code);
			// 	if(this.objData.staff_info_code!='' && this.objData.staff_info_code){
			// 	// for (let i = 0; i < this.masObjects.length; i++) {}
			// 		if(typeof this.objStaffExtra[this.objData.staff_info_code] == 'undefined'){
			// 			this.$GVO.ApiCall('staff.GET_STAFF_EXTRA_DATA',{flt:{'code':this.objData.staff_info_code}})
			// 			.then((objApi) => {
			// 				if(objApi.success === true){
			// 					this.objStaffExtra[this.objData.staff_info_code] = objApi.data[0];
			// 					// console.log('this.objData.staff_info_code',this.objStaffExtra[this.objData.staff_info_code]);
			// 				}
			// 			}).catch(errorObjApi => {console.log(errorObjApi);});
			// 		}
			// 	}	
				

			// },

		},
		mounted(){

		},

	}
</script>
<style scoped>

.ReLeadStaffInfo {display: flex; flex-direction: column;}
/* .ReLeadStaffInfo >>> .tree-list ul li, .ReLeadStaffInfo >>> .tree-list span, .ReLeadStaffInfo h6, .ReLeadStaffInfo p  {color: #303133;} */
/* .white-content .card:not(.card-white) >>> .ReLeadStaffInfo >>> .tree-list ul li, .white-content .card:not(.card-white) >>> .ReLeadStaffInfo >>> .tree-list span, .white-content .card:not(.card-white) >>> .ReLeadStaffInfo h6, .white-content .card:not(.card-white) >>> .ReLeadStaffInfo p  {color: #303133!important;} */
.ReLeadStaffInfo >>> .tree-list ul li, .ReLeadStaffInfo >>> .tree-list span, .ReLeadStaffInfo h6, .ReLeadStaffInfo p  {color: #303133!important;}
.bossBlock, .staffBlock {display: flex; flex-direction: column;  }
.bossBlock {border-top: 1px dashed #01B0E0;}
/* .ReLeadCallCat{
	padding: 10px;
	border: 1px dashed #01B0E0;
	border-radius: 6px;
	width: 960px;
}
.ReLeadCallCat >>> .ReInputSearchDrop {width: 100%;}
.ReLeadCallCat >>> .ReInputSearchDrop > .form-group {width: 100%;}
.ReLeadCallCat >>> .callSearchDrop {display: flex; flex-direction: row;}

@media (max-width: 1300px){
	.ReLeadCallCat{width: 100%;}
} */

</style>
